/**
 * Canonical WebSocket namespace strings (single source of truth, D-04).
 *
 * Two namespaces enforce two distinct trust boundaries (PITFALLS #4):
 * a customer socket can never join an agent room.
 */
export const WS_NAMESPACES = {
    /** Customer-facing widget namespace (built in Plan 02). */
    CUSTOMER: '/customer',
    /** Agent-facing portal namespace (built in this plan). */
    AGENT: '/agent',
} as const;

export type WsNamespace = (typeof WS_NAMESPACES)[keyof typeof WS_NAMESPACES];
